/**
 * Phase 5h/5j/21/22 — synchroner Lesepfad für Services (Cache ∪ entity_* ∪ merged Blob).
 * UI bevorzugt async `list*ForBusiness` aus container.js.
 */

import { readLotsSyncForBusiness } from '../../utils/lotsReadSource';
import { readProductsSyncForBusiness } from '../../utils/productsReadSource';
import { readPurchasesSyncForBusiness } from '../../utils/purchasesReadSource';
import { readSalesSyncForBusiness } from '../../utils/salesReadSource';
import { readCustomersSyncForBusiness } from '../../utils/customersReadSource';
import { readSuppliersSyncForBusiness } from '../../utils/suppliersReadSource';
import { readStockDataSyncForBusiness } from '../../utils/stockDataReadSource';
import { readInvoicesSyncForBusiness } from '../../utils/invoicesReadSource';
import { readOrdersSyncForBusiness } from '../../utils/ordersReadSource';
import { readExpensesSyncForBusiness } from '../../utils/expensesReadSource';
import { readInvoicePaymentsSyncForBusiness } from '../../utils/invoicePaymentsReadSource';
import { readSupplierDebtsSyncForBusiness } from '../../utils/supplierDebtsReadSource';
import { readCustomerDebtsSyncForBusiness } from '../../utils/customerDebtsReadSource';
import { readCustomerInvoicesSyncForBusiness } from '../../utils/customerInvoicesReadSource';
import { readSupermarketPaymentsSyncForBusiness } from '../../utils/supermarketPaymentsReadSource';
import { readSupermarketInvoicesSyncForBusiness } from '../../utils/supermarketInvoicesReadSource';
import { readExpiredProductsSyncForBusiness } from '../../utils/expiredProductsReadSource';
import { readNotificationsSyncForBusiness } from '../../utils/notificationsReadSource';
import { readWorkerSessionsSyncForBusiness } from '../../utils/workerSessionsReadSource';
import { readReportsSyncForBusiness } from '../../utils/reportsReadSource';
import { readDiscrepancyManagementSyncForBusiness } from '../../utils/discrepancyManagementReadSource';
import { readStockLocationsSyncForBusiness } from '../../utils/stockLocationsReadSource';
import { readPersistentStockDataSyncForBusiness } from '../../utils/persistentStockDataReadSource';
import { readOfflineQueueSyncForBusiness } from '../../utils/offlineQueueReadSource';
import { readBusinessInfoSyncForBusiness } from '../../utils/businessInfoReadSource';
import { readUserInfoSyncForBusiness } from '../../utils/userInfoReadSource';
import { readMetadataSyncForBusiness } from '../../utils/metadataReadSource';
import { readStockMovementsSyncForBusiness } from '../../utils/stockMovementsReadSource';

export {
  readLotsSyncForBusiness,
  readProductsSyncForBusiness,
  readPurchasesSyncForBusiness,
  readSalesSyncForBusiness,
  readCustomersSyncForBusiness,
  readSuppliersSyncForBusiness,
  readStockDataSyncForBusiness,
  readInvoicesSyncForBusiness,
  readOrdersSyncForBusiness,
  readExpensesSyncForBusiness,
  readInvoicePaymentsSyncForBusiness,
  readSupplierDebtsSyncForBusiness,
  readCustomerDebtsSyncForBusiness,
  readCustomerInvoicesSyncForBusiness,
  readSupermarketPaymentsSyncForBusiness,
  readSupermarketInvoicesSyncForBusiness,
  readExpiredProductsSyncForBusiness,
  readNotificationsSyncForBusiness,
  readWorkerSessionsSyncForBusiness,
  readReportsSyncForBusiness,
  readDiscrepancyManagementSyncForBusiness,
  readStockLocationsSyncForBusiness,
  readPersistentStockDataSyncForBusiness,
  readOfflineQueueSyncForBusiness,
  readBusinessInfoSyncForBusiness,
  readUserInfoSyncForBusiness,
  readMetadataSyncForBusiness,
  readStockMovementsSyncForBusiness
};

/**
 * Feld-Snapshot für Legacy-Service-Pfade (entity_* hat Vorrang bei Authority).
 * @param {string} businessId
 */
export function readBusinessPayloadFieldsSync(businessId) {
  if (!businessId) {
    return {
      lots: [],
      products: [],
      purchases: [],
      sales: [],
      customers: [],
      suppliers: [],
      stockData: {},
      invoices: [],
      orders: [],
      expenses: [],
      invoicePayments: [],
      supplierDebts: [],
      customerDebts: [],
      customerInvoices: [],
      supermarketPayments: [],
      supermarketInvoices: [],
      expiredProducts: [],
      notifications: [],
      workerSessions: [],
      reports: {},
      discrepancyManagement: {},
      stockLocations: [],
      persistentStockData: [],
      offlineQueue: [],
      businessInfo: null,
      userInfo: null,
      metadata: {},
      stockMovements: []
    };
  }

  return {
    lots: readLotsSyncForBusiness(businessId),
    products: readProductsSyncForBusiness(businessId),
    purchases: readPurchasesSyncForBusiness(businessId),
    sales: readSalesSyncForBusiness(businessId),
    customers: readCustomersSyncForBusiness(businessId),
    suppliers: readSuppliersSyncForBusiness(businessId),
    stockData: readStockDataSyncForBusiness(businessId),
    invoices: readInvoicesSyncForBusiness(businessId),
    orders: readOrdersSyncForBusiness(businessId),
    expenses: readExpensesSyncForBusiness(businessId),
    invoicePayments: readInvoicePaymentsSyncForBusiness(businessId),
    supplierDebts: readSupplierDebtsSyncForBusiness(businessId),
    customerDebts: readCustomerDebtsSyncForBusiness(businessId),
    customerInvoices: readCustomerInvoicesSyncForBusiness(businessId),
    supermarketPayments: readSupermarketPaymentsSyncForBusiness(businessId),
    supermarketInvoices: readSupermarketInvoicesSyncForBusiness(businessId),
    expiredProducts: readExpiredProductsSyncForBusiness(businessId),
    notifications: readNotificationsSyncForBusiness(businessId),
    workerSessions: readWorkerSessionsSyncForBusiness(businessId),
    reports: readReportsSyncForBusiness(businessId),
    discrepancyManagement: readDiscrepancyManagementSyncForBusiness(businessId),
    stockLocations: readStockLocationsSyncForBusiness(businessId),
    persistentStockData: readPersistentStockDataSyncForBusiness(businessId),
    offlineQueue: readOfflineQueueSyncForBusiness(businessId),
    businessInfo: readBusinessInfoSyncForBusiness(businessId),
    userInfo: readUserInfoSyncForBusiness(businessId),
    metadata: readMetadataSyncForBusiness(businessId),
    stockMovements: readStockMovementsSyncForBusiness(businessId)
  };
}
